import { t } from 'i18next';
import * as yup from 'yup';

import { Account } from '~hooks/useAccount/models';

export const notesSchema = yup.object().shape({
  notes: yup
    .string()
    .max(
      350,
      `${t('form_validation_errors.max_length', {
        field: t('form_fields.notes'),
        max: 350,
      })}`,
    )
    .notRequired(),
});
export type NotesDto = yup.InferType<typeof notesSchema>;

export function setNotesSchemaDefaultValues(account?: Account) {
  const defaultValues: NotesDto = { notes: account?.notes ?? '' };

  return defaultValues;
}
